import React from "react"; 
import { Button } from '../../Atoms';
import { Link } from 'react-router-dom';

 
import img3 from "../../Assets/relatedProduct/Simulator.webp";
import img4 from "../../Assets/relatedProduct/Simulator3phase.webp";
 
const cardData = [
    {
        title: "Type 2 EV Simulator",
        description: "VerdeMobility’s Type 2 EV Simulator is an innovation enabling on-field troubleshooting of EVSEs, on-the-move!",
        link: "",
        merged: true, // spans the left two columns, text-only
    },
    {
        title: "EV Simulator Single-Phase",
        description: "Simulate EV charging behaviour and communication for development and testing.",
        image: img3,
        link: "/evsimulator#simulator",
    },
    {
        title: "EV Simulator Three-Phase",
        description: "Simulate EV charging behaviour and communication for development and testing.",
        image: img4,
        link: "/evsimulator#simulator3phase",
    },
];

const EVChargingSolutions = () => {
    return (
        <section className="blade-margin-top-sm">
        <div className="containers-min mx-auto px-4 py-12">
             <h3 className="font-gilroy mb-4 h3 text-4xl"> Related Products</h3> 
            <div className="flex gap-4 flex-wrap lg:flex-nowrap justify-around">
                <div className="basis-full lg:basis-[calc(50%+1rem)] shrink-0">
                    <MergedTextCard {...cardData[0]} />
                </div>
                <div>
                    <DataCard {...cardData[1]} />
                </div>
                <div>
                    <DataCard {...cardData[2]} />
                </div>
            </div>
        </div>
        </section>
    );
};

// Text-only card replacing the merged left two columns
const MergedTextCard = ({ title, description, link }) => {
    const isExternal = link?.startsWith("http");
    const isClickable = Boolean(link);

    const content = (
        <div className="h-[225px] Lg:h-[380px] xxl:h-[280px] flex flex-col justify-center px-6 rounded-2xl bg-gradient-opa">
            <span className="text-3xl font-bold font-gilroy mb-3">
                {title}
            </span>
            <p className="leading-normal font-poppins text-lg max-w-[90%]">
                {description}
            </p>
        </div>
    );

    const sharedClassName =
        "relative flex flex-col self-stretch grow shrink mx-auto rounded-2xl overflow-hidden" +
        (isClickable ? " cursor-pointer" : " cursor-default");

    if (!isClickable) {
        return <div className={sharedClassName}>{content}</div>;
    }

    return (
        <Link
            to={link}
            target={isExternal ? "_blank" : undefined}
            rel={isExternal ? "noopener noreferrer" : undefined}
            className={sharedClassName}
        >
            {content}
        </Link>
    );
};

// Unchanged — used for the two right-side product cards
const DataCard = ({ title, description, image, link }) => {
    const isExternal = link?.startsWith("http");
    const isClickable = Boolean(link);

    const content = (
        <div className="group h-[225px] Lg:h-[380px] xxl:h-[280px] overflow-hidden grow-0 relative">
            <img
                loading="lazy"
                src={image}
                alt={title}
                className="h-full w-full object-cover "
            />

            <div className="absolute bottom-0 left-0 right-0 bg-gradient-opa py-3 px-4 text-center transition-opacity duration-500 group-hover:opacity-0 z-10">
                <span className="text-xl font-bold font-gilroy">
                    {title}
                </span>
            </div>

            <div className="absolute inset-0 bg-gradient-opa transform translate-y-full group-hover:translate-y-0 transition-transform duration-[1s] flex flex-col items-center justify-center text-center px-4 gap-3 z-20">
                <span className="text-3xl font-bold font-gilroy">
                    {title}
                </span>
                <div className="leading-normal font-poppins text-center text-lg max-w-[90%]">
                    <p className="leading-normal font-poppins text-start text-lg">{description}</p>
                </div>
            </div>
        </div>
    );

    const sharedClassName =
        "basis-96 relative flex flex-col self-stretch grow shrink mx-auto rounded-2xl overflow-hidden group" +
        (isClickable ? " cursor-pointer" : " cursor-default");

    if (!isClickable) {
        return <div className={sharedClassName}>{content}</div>;
    }

    return (
        <Link
            to={link}
            target={isExternal ? "_blank" : undefined}
            rel={isExternal ? "noopener noreferrer" : undefined}
            className={sharedClassName}
        >
            {content}
        </Link>
    );
};

export default EVChargingSolutions;